export default __webpack_public_path__ + "static/media/Titel_image_Kaapse.535e954b.jpg";